module.exports = __webpack_public_path__ + "a52b01abcbbc808aa244040a68ca412e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-5.png
// module id = 2267
// module chunks = 0